import { CheckboxOptionType } from 'antd';
import { GenderTypes } from 'common/schema/supplier/GenderTypes';

export const genderOptions: CheckboxOptionType[] = [
  { label: 'M', value: GenderTypes.M },
  { label: 'F', value: GenderTypes.F }
];
